$ () ->

    $.widget 'custom.myUploader',
        options:
            plupload_options: null
            # DO NOT pass in an element that has an ID here.
            # It will work, but the id will be destroyed.
            add_btn: null

            beforeInit: () -> undefined
            onInit: () -> undefined

        default_plupload_opts:
            runtimes: 'html5,flash,silverlight'
            flash_swf_url: 'bower_components/plupload/js/Moxie.swf'
            silverlight_xap_url: 'bower_components/plupload/js/Moxie.xap'
            multi_selection: true
            max_file_size: '1000mb'
            max_file_count: 200
            chunk_size: '1mb'



        _init: () ->
            if not @options.add_btn? or @options.add_btn.length is 0
                throw Error 'myUploader: you must specify an add_btn'

            id = (new Date()).getTime() + '_add_btn'

            @options.add_btn.attr('id', id)

            plup_options = $.extend(@default_plupload_opts, @options.plupload_options ? {})
            plup_options.browse_button = id

            @uploader = new plupload.Uploader plup_options

            if @options.beforeInit?
                @options.beforeInit(@element, @uploader)

            # Debuggy!
            # @uploader.bind 'Init', (up, params) =>
            #    @element.find('.filelist').html("<div>Current runtime: " + params.runtime + "</div>")

            @uploader.init()

            @uploader.bind 'FilesAdded', (up, files) =>
                last_file_group = null

                $.each(files, (i, file) =>
                    next_file_group = file.name.match(/[^.]*/)[0]

                    if @options.addRowCallback?
                        @options.addRowCallback(i, file)
                    else
                        row = "<tr id='#{file.id}' data-file-group='#{next_file_group}'>
                                <td class='file-name-spacing'>
                                    <span class='nowrap' title='#{file.name}'>#{file.name}</span>
                                </td>
                                <td class='upload-status'>
                                    <div class='progress-green progress'>
                                        <div class='bar'></div>
                                    </div>
                                </td>
                                <td>#{plupload.formatSize(file.size)}</td>"

                        if next_file_group isnt last_file_group
                            row += "<td>
                                    <button class='btn btn-mini btn-danger upload-remove-file'>
                                        <i class='fas fa-trash-alt'></i>
                                    </button>
                                </td>
                            </tr>"
                        else
                            row += '<td></td>
                                </tr>'

                        last_file_group = next_file_group
                        @element.find('.filelist').append(row)


                )

                @calculateTotalFileSize()

                up.refresh() # Reposition Flash/Silverlight

                up.start()


            @element.on 'click', '.upload-remove-file', (e) =>
                elem = $(e.target)
                file_group = elem.closest('tr').attr('data-file-group')
                file_rows = elem.closest('table').find('tr[data-file-group = "' + file_group + '"]')
                for row in file_rows
                    id = $(row).attr('id')
                    @uploader.removeFile(@uploader.getFile id)


            @uploader.bind 'FilesRemoved', (up, files) =>
                for file in files
                    @element.find("##{file.id}").remove()

                @calculateTotalFileSize()


            @uploader.bind 'FileUploaded', (up, file) =>
                elem = @element.find('.filelist').find('#' + file.id + ' .upload-status .bar')
                elem.animate
                    width: '100%'
                , 2


            @uploader.bind 'UploadProgress', (up, file) =>
                elem = @element.find('.filelist').find('#' + file.id + ' .upload-status .bar')#.html(file.percent + "%")
                if parseInt(file.percent) > 0
                    elem.animate
                        width: file.percent + '%'
                    , 2


            @uploader.bind 'UploadComplete', (up, files) =>
                if @options.onComplete?
                    @options.onComplete(@element, @uploader)
                if @options.plupload_options.onComplete?
                    @options.plupload_options.onComplete(@element, @uploader)


            if @onInit?
                @options.onInit(@element, @uploader)


        _create: () ->
            undefined

        _setOption: () ->
            undefined

        destroy: () ->
            undefined

        getUploader: () ->
            return @uploader


        calculateTotalFileSize: () ->
            size = 0
            $.each @uploader.files, (i, file) =>
                size += file.size

            @element.find('.upload-total-size').html(plupload.formatSize(size))
